// extracted by mini-css-extract-plugin
module.exports = {"root":"LiveStageStatus_root__OgB6K","date":"LiveStageStatus_date__O2KBz","content":"LiveStageStatus_content__aT2Y3","time":"LiveStageStatus_time___xT4f"};